import React, { useCallback } from "react";
import { HeaderProminentButton } from "./HeaderProminentButton";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { useFocusEnd } from "../useFocusEnd";
import { StorecastState } from "../types";
import { useSizeClass } from "../../../../common/Utils/useSizeClass";
import { Box } from "arkh";

export function StorecastFocusEndButton({
  dashboard,
  setStorecastState,
}: {
  dashboard: { id: string };
  setStorecastState(state: StorecastState): void;
}) {
  const intl_tokens = useIntlTokens();
  const endFocus = useFocusEnd(dashboard.id);
  const onPressFocusEnd = useCallback(() => {
    setStorecastState("IDLE");
    endFocus();
  }, [endFocus, setStorecastState]);
  const isCompact = useSizeClass();
  return (
    <Box spaceLeft={isCompact ? "small" : "medium"} spaceRight="small">
      <HeaderProminentButton
        onPress={onPressFocusEnd}
        title={intl_tokens.End}
        icon="focus-mode"
      />
    </Box>
  );
}
